import React from "react";
import styled from "styled-components";
import { MenuContainer } from "../../components/menuContainer/MenuContainer";
import { motion } from "framer-motion";

const Content = styled.section`
  background-color: var(--bs-skyblue);
  border-radius: 10px;
  padding: 90px;
  position: relative;
  min-height: 72rem;
`;

const Line = styled.section`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  @media (max-width: 767px) {
    left: 20%;
    transform: translate(0, 0);
  }

  img {
    display: block;
    left: 50%;
    transform: translate(-50%, 0);
  }
`;

const Left = styled.div`
  position: absolute;
  left: 50%;
  text-align: end;
  transform: translate(-140%, 0);
  @media (max-width: 767px) {
    left: 30%;
    transform: translate(0, 0);
    text-align: start;
  }

  h2 {
    font-weight: bold;
  }
`;

const Right = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(30%, 0);
  @media (max-width: 767px) {
    left: 30%;
    transform: translate(0, 0);
  }

  h2 {
    font-weight: bold;
  }
`;

export const History = () => (
  <MenuContainer title="회사소개" menu="연혁" pointRadius="50%">
    <div className="comment-wrapper">
      <motion.div
        className="comment"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{
          ease: "easeInOut",
          duration: 1,
          y: { duration: 0.5 },
        }}
      >
        "서진로지텍은 변화를 선도하며,
        <br />
        고객과 함께 성장하여 더 나은 미래를 만듭니다."
      </motion.div>
      <motion.div
        className="detailed-comment"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{
          ease: "easeInOut",
          duration: 1,
          y: { duration: 0.5 },
        }}
      >
        효율적인 물류 네트워크와 지속 가능한 경영으로&nbsp;
        <span className="d-block d-md-none" />
        새로운 가치를 창출합니다.
      </motion.div>
    </div>
    <Content>
      <Line
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{
          ease: "easeInOut",
          duration: 1,
          y: { duration: 0.5 },
        }}
      >
        <img
          src="/history-components/equal.svg"
          alt="history top"
          width={29}
          height={11}
        />
        <img
          src="/history-components/line-short.svg"
          alt="history line"
          width={3}
          height={126}
        />
        <img
          src="/history-components/double-circle.svg"
          alt="history circle"
          height={19}
          width={19}
          style={{ margin: "8px 0" }}
        />
        <img
          src="/history-components/line-long.svg"
          alt="history line"
          width={3}
          height={188}
        />
        <img
          src="/history-components/double-circle.svg"
          alt="history circle"
          height={19}
          width={19}
          style={{ margin: "8px 0" }}
        />
        <img
          src="/history-components/line-long.svg"
          alt="history line"
          width={3}
          height={188}
        />
        <img
          src="/history-components/double-circle.svg"
          alt="history circle"
          height={19}
          width={19}
          style={{ margin: "8px 0" }}
        />
        <img
          src="/history-components/line-long.svg"
          alt="history line"
          width={3}
          height={188}
        />
        <img
          src="/history-components/double-circle.svg"
          alt="history circle"
          height={19}
          width={19}
          style={{ margin: "8px 0" }}
        />
        <img
          src="/history-components/line-short.svg"
          alt="history line"
          width={3}
          height={126}
        />
      </Line>
      <Left style={{ top: "13.1rem" }}>
        <h2>2014. 10. 08</h2>
        <p>
          광양항 서측배후단지 5구역
          <br />
          자유무역지역 입주허가서 교부
        </p>
      </Left>
      <Right style={{ top: "27rem" }}>
        <h2>2014. 12. 08</h2>
        <p>
          광양항 배후단지
          <br />
          임대차 계약서 체결
        </p>
      </Right>
      <Left style={{ top: "41rem" }}>
        <h2>2015. 10</h2>
        <p>제 1창고 및 포장야드 준공</p>
      </Left>
      <Right style={{ top: "55rem" }}>
        <h2>2020. 02</h2>
        <p>
          제 2창고, 제 3창고
          <br />
          포장야드 확장 준공
        </p>
      </Right>
    </Content>
  </MenuContainer>
);
